export default __webpack_public_path__ + "static/media/doctorPhoto.9a37d6de.png";